<template>
  <div class="mb-5">
    <GenericBoxHeader variant="highlight">
      Texto complementar
    </GenericBoxHeader>

    <div class="content" v-html="courseClass.content"></div>
  </div>
</template>

<script>
  import GenericBoxHeader from '@/components/boxes/GenericBoxHeader'

  export default {
    components: {
      GenericBoxHeader,
    },

    props: {
      courseClass: { type: Object, required: true }
    }
  }
</script>

<style scoped lang="scss">
  .header {
    background: #ff8000;
    color: #fff !important;
  }

  ::v-deep .content {

    &, * { font-family: 'Poppins' !important; color: #3b454e }

    h2 { font-size: 1.875rem; font-weight: 700 }

    h3 { font-size: 1.5625rem }

    h2, h3 { margin-bottom: 0 }

    p, span, em { line-height: 1.875rem }

    a {
      color: #ff8000;

      &:hover { text-decoration: underline!important }
    }

    img { display: block; max-width: 100%; width: auto; margin-bottom: 20px }

    p {
      display: block;
      font-size: 1.125rem;

      &:not(:last-child) { margin-bottom: 20px }
    }
  }
</style>